import React from 'react';
import { Radar } from 'react-chartjs-2';

export const RadarChart = props => {
  return (
    <div className="chart">
      <Radar data={props.chartData}
        options={{
          scale: {
            ticks: {
              beginAtZero: true,
              gridLines: {
                borderDash: [4, 4],
                color: 'rgba(#ffffff,0.8)'
              },
            },
            labels: {
              fontFamily: 'Gilroy-Bold',
            }
          },
          legend: {
            display: false
          },
          plugins: {
            datalabels: false
          }
        }} />
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/screens/AssessmentReport/components/RadarChart/RadarChart.js